import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';

import Foundation from './Foundation';
import Header from '../partials/header';
import Footer from '../partials/footer';
import AnnouncementBar from '../partials/AnnouncementBar';

const BaseLayout = ({ children, noFooter, headerProps, footerProps }) => {
  const {
    announcementBar: { childDataYaml: announcementBar },
  } = useStaticQuery(graphql`
    query AnnouncementBarData {
      announcementBar: file(name: { eq: "announcement-bar" }) {
        childDataYaml {
          show
          blurb
          cta {
            label
            show
            url
          }
          onlyCommunity
          variation
        }
      }
    }
  `);

  return (
    <Foundation>
      <AnnouncementBar
        show={
          announcementBar.show &&
          ((announcementBar.onlyCommunity && headerProps.community) ||
            !announcementBar.onlyCommunity)
        }
        content={announcementBar.blurb}
        button={announcementBar.cta}
        variation={announcementBar.variation}
      />
      <div className="site-wrapper">
        <Header {...headerProps} />
        {children}
        {!noFooter && <Footer {...footerProps} />}
      </div>
    </Foundation>
  );
};

BaseLayout.propTypes = {
  children: PropTypes.node.isRequired,
  noFooter: PropTypes.bool,
  headerProps: PropTypes.shape({
    contrast: PropTypes.bool,
    community: PropTypes.bool,
    forceCTAContrast: PropTypes.bool,
    sticky: PropTypes.bool,
    showNav: PropTypes.bool,
    showPrimaryLogo: PropTypes.bool,
  }),
  footerProps: PropTypes.shape({
    hideCTA: PropTypes.bool,
  }),
};

export default BaseLayout;
